module.exports = new __parcel__URL__("contact_side_icon.61029408.png").toString();